import { render, staticRenderFns } from "./StafferView.vue?vue&type=template&id=e538c550&scoped=true&"
import script from "./StafferView.vue?vue&type=script&lang=js&"
export * from "./StafferView.vue?vue&type=script&lang=js&"
import style0 from "./StafferView.vue?vue&type=style&index=0&id=e538c550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e538c550",
  null
  
)

export default component.exports